import { L } from '@lib';
import { CreateOrUpdateUserInput } from '@services';
import { Col, Row, Typography } from 'antd';
import React from 'react';
import { SharedCard } from '.';
import './AccountDetailsCard.css';
import { useView } from '@hooks';
const { Title, Text } = Typography;

interface IProps {
  user: CreateOrUpdateUserInput;
}

export const AccountDetailsCard: React.FC<IProps> = ({ user }) => {
  const { isMobile } = useView();
  return (
    <SharedCard>
      <Row className="myAccountDetailWrapper" gutter={[16, 16]}>
        <Col span={isMobile ? 24 : 4}>
          <Title className="myAccountCardTitle mT0">{L('General Information')}</Title>
        </Col>
        <Col span={isMobile ? 24 : 6} className="y-padding">
          <Text className="myAccountDetailTitle">{L('Email')}</Text>
          <br />
          <Text className="myAccountDetailValue">{user.emailAddress}</Text>
        </Col>
        <Col span={isMobile ? 24 : 6} className="y-padding">
          <Text className="myAccountDetailTitle">{L('Phone')}</Text>
          <br />
          <Text className="myAccountDetailValue">{user.phoneNumber}</Text>
        </Col>
      </Row>
    </SharedCard>
  );
};
